/* eslint-disable */
import React, { useState } from 'react';
import '../css/EmployeeCreateDocPage.css';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import parse from 'html-react-parser';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const CreateDoc = () => {
  const [text, setText] = useState('');

  return (
    <div className="doc-body">
      <a
        style={{
          fontsize: '120px',
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          padding: 40,
          color: 'white',
        }}
        href="profile-page"
      >
        <ArrowBackIcon />
        <span>&nbsp;Back</span>
      </a>
      <div className="row no-gutters">
        <div className="col-lg-6">
          <div className="leftside">
            <form className="form">
              <div className="input-field">
                <label>Title</label>
                <input type="text" className="title" />
              </div>

              <div className="input-field">
                <label>Author</label>
                <input type="text" className="input1" />
              </div>

              <div className="input-field">
                <label>Content</label>
                <CKEditor
                  className="editor"
                  editor={ClassicEditor}
                  data={text}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setText(data);
                  }}
                />
              </div>
            </form>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="rightside">
            <h1>Title</h1>
            <p>{parse(text)}</p>
          </div>
        </div>
      </div>

      <div className="footer">
        <p className="copyright-text">
          &copy;
          <a style={{ fontSize: '14px' }} href="/about">
            {' '}
            Advanced Intelligence Services Corp.
          </a>
          &nbsp; All rights reserved.
        </p>
        <div className="footer-container">
          <a href="/termsofuse">Terms of Use</a>
          <a href="/privacypolicy">Privacy Policy</a>
        </div>
      </div>
    </div>
  );
};

export default CreateDoc;
